import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const CloseIcon: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--closeIcon')}
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g
      id="closeIcon"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M16.0015698,14.9393398 L23.6029677,7.33794193 L24.6636279,8.3986021 L17.06223,16 L24.6636279,23.6013979 L23.6029677,24.6620581 L16.0015698,17.0606602 L8.40017192,24.6620581 L7.33951175,23.6013979 L14.9409097,16 L7.33951175,8.3986021 L8.40017192,7.33794193 L16.0015698,14.9393398 Z"
        id="Close"
        fill="#000000"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default CloseIcon;
